import { render } from "./RoleMenu.vue?vue&type=template&id=4ee9d156&scoped=true&ts=true"
import script from "./ts/roleMenuHelper.ts?vue&type=script&lang=ts"
export * from "./ts/roleMenuHelper.ts?vue&type=script&lang=ts"

import "./RoleMenu.vue?vue&type=style&index=0&id=4ee9d156&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee9d156"]])

export default __exports__